<template>
    <page showBackButton>
        <contract-card :contractId="contractId"></contract-card>
        <h1>
            Auszahlung Gutschein&nbsp;<ion-button
                fill="clear"
                color="dark"
                @click="showInfo()"
                class="-no-padding"
                style="vertical-align: middle;"
            >
                <ion-icon
                    name="information-circle-outline"
                    slot="icon-only"
                ></ion-icon>
            </ion-button>
        </h1>
        <p>Hallo {{ $store.state.user.details.vorname }},</p>
        <p>
            dein Danke-Bonus im Wert von 3 Monatsprämien deiner
            Kfz-Haftpflichtversicherung wartet schon auf dich!
        </p>
        <h3 class="ion-text-center">
            <b>{{ bonus | currency }}</b>
        </h3>
        <p class="u-m-bottom-none">
            Gib bitte einfach den im Gutschein eingedruckten Code hier ein:
        </p>
        <base-input
            id="code"
            v-model="code"
            type="text"
            label="Gutscheincode"
            clearInput
        ></base-input>
        <p class="u-m-bottom-none">
            Wir überweisen dir den Bonus auf dein hinterlegtes Konto. Du kannst
            gerne auch ein anderes Konto angeben:
        </p>
        <base-input
            id="iban"
            v-model="iban"
            type="text"
            label="IBAN"
            :mask="{ mask: 'aa00 0000 0000 0000 0000 00' }"
            @onAccept="unmaskedIban = $event"
            clearInput
        ></base-input>
        <!-- <base-input
            id="inhaber"
            v-model="accountHolderName"
            type="text"
            label="Inhaber"
            clearInput
        ></base-input> -->
        <!-- <ion-list>
            <ion-list-header>
                <ion-label>Bankdaten</ion-label>
                <ion-button
                    fill="clear"
                    color="danger"
                    style="--padding-end: 0px; --padding-start: 0px;"
                    size="small"
                    @click="editBankdata()"
                >
                    Bearbeiten
                </ion-button>
            </ion-list-header>
            <ion-item>
                <ion-label class="ion-text-wrap">IBAN</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">{{
                    iban
                }}</ion-label>
            </ion-item>
            <ion-item>
                <ion-label class="ion-text-wrap">Inhaber</ion-label>
                <ion-label class="ion-text-wrap ion-text-right">{{
                    accountHolderName
                }}</ion-label>
            </ion-item>
        </ion-list> -->
        <p>Danke für deine Treue und weiterhin gute Fahrt!</p>
        <ion-button expand="block" @click="submit()"
            >Auszahlung bestätigen</ion-button
        >
    </page>
</template>

<script>
import Page from "@/components/Page";
import ContractCard from "@/components/ContractCard";
import BaseInput from "@/components/BaseInput";
import { KFZPromoSubmit } from "@/api/gutschein";
import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;

export default {
    props: {
        contractId: {
            required: true,
            type: String,
        },
    },
    components: {
        Page,
        ContractCard,
        BaseInput,
    },
    data() {
        return {
            iban: "",
            unmaskedIban: "",
            accountHolderName: "",
            code: "",
        };
    },
    mounted() {
        this.$store.cache
            .dispatch("contractsDetails/getContractDetails", this.contractId)
            .then(() => {
                if (this.contractId in this.$store.state.contractsDetails.all) {
                    const contractDetails = this.$store.state.contractsDetails
                        .all[this.contractId];
                    if (contractDetails.BankAccountData) {
                        if (contractDetails.BankAccountData.AccountHolderName) {
                            this.accountHolderName =
                                contractDetails.BankAccountData.AccountHolderName;
                        }
                        if (contractDetails.BankAccountData.Iban) {
                            this.iban = contractDetails.BankAccountData.Iban;
                        }
                    }
                }
            });
    },
    methods: {
        showInfo() {
            this.$ionic.alertController
                .create({
                    header: "Hinweis",
                    message: "Aktion gültig 18.9. – 31.12.2020",
                    buttons: ["Verstanden"],
                })
                .then((a) => {
                    a.present();
                });
        },
        submit() {
            this.$store.commit("setLoading", true);
            KFZPromoSubmit(this.code, this.unmaskedIban).then((response) => {
                if (response.data.Status === 200) {
                    Storage.set({
                        key: "hideVoucher",
                        value: "true",
                    });
                    this.$ionic.alertController
                        .create({
                            header: "Auszahlung Bestätigung",
                            message:
                                "<p>Dein Danke-Bonus wird dir in Kürze auf dein Konto überwiesen. Gute Fahrt!</p><p>Dein Wüstenrot Team<br>#staysafe</p>",
                            buttons: ["Ok"],
                        })
                        .then((a) => {
                            a.onDidDismiss().then(() => {
                                this.$router.go(-1);
                            });
                            a.present();
                        });
                }
            });
        },
    },
    computed: {
        bonus() {
            let result = "";
            if (
                this.$store.state.contracts[this.contractId] &&
                this.$store.state.contracts[this.contractId].KFZPromo &&
                this.$store.state.contracts[this.contractId].KFZPromo.Bonus
            ) {
                result = this.$store.state.contracts[this.contractId].KFZPromo
                    .Bonus;
            }
            return result;
        },
    },
};
</script>

<style></style>
